import React from 'react';
import { useIntl } from 'react-intl';
import { api, profilePhotouploadDir } from '../../../config';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';
import { Button } from 'react-bootstrap';
import cx from "classnames";

import StarRating from '../../StarRating/StarRating';
import messages from '../../../locale/messages';
import defaultIcon from '../../../../public/dashboard/defaultIconMenu.svg';
import withStyles from 'isomorphic-style-loader/withStyles';
import bt from '../../../components/commonStyle.css';
import s from './PreferredProviderDetails.css';

// Parity with the app card: each worker shows name, rating, completed jobs, distance, and THEIR own
// price for this order. Shape comes from getServiceProvider (flat: firstName/lastName/picture/count/
// price/distance), not the old nested {profile, completedBookingCount}.
function PrefferedProviderDetails({ providerData }) {
    const {
        id,
        firstName,
        lastName,
        picture,
        overallRating,
        count,
        distance,
        price,
        currency,
    } = providerData;

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();

    const selectedPartnerId = useSelector(state => state.form?.PreferredProviderForm?.values?.preferredPartnerId);

    const isSelected = selectedPartnerId === id;
    const isDisabled = selectedPartnerId && !isSelected;

    const handleAdd = () => {
        dispatch(change('PreferredProviderForm', 'preferredPartnerId', id));
    };

    const handleRemove = () => {
        dispatch(change('PreferredProviderForm', 'preferredPartnerId', null));
    };

    return (
        <div className={s.preferredProviderCard}>
            <div className={s.preferredProviderImageWrapper}>
                {/* Use the FULL image like the app (constants.profileImagePath + picture) — the
                    `medium_` thumbnail isn't generated for every worker, so it 404'd (e.g. Tariq). */}
                <img src={picture ? `${api.apiEndpoint}${profilePhotouploadDir}${picture}` : defaultIcon} alt="userProfile" />
            </div>
            <div className={s.preferredProviderCardInnerFlex}>
                <div>
                    <p className={s.providerName}>{firstName}{lastName ? ` ${lastName}` : ''}</p>
                    <StarRating value={overallRating} className={s.providerRatingWrapper} />
                    <p className={s.providerServiceCount}>{formatMessage(messages.completedServices)} {count || 0}</p>
                    {distance != null && <p className={s.providerServiceCount}>{Number(distance).toFixed(1)} mi away</p>}
                    {price != null && <p className={cx(bt.fontWeight700, bt.commonSize16, bt.primaryColor)}>{currency ? `${currency} ` : ''}{Number(price).toFixed(2)}</p>}
                </div>
                <div className={s.providerButtonWrapper}>
                    {isSelected ? (
                        <a href={'#'} onClick={handleRemove} tabIndex={0} className={cx(bt.commonLinkWithOutBorder, s.removeLinkButton)}> {formatMessage(messages.remove)} </a>
                    ) : (
                        <Button onClick={handleAdd} disabled={isDisabled} className={cx(bt.btnPrimary, bt.primarySmall, bt.fontWeight700, isDisabled ? bt.buttonDisableGray : '')}> {formatMessage(messages.select)} </Button>
                    )}
                </div>
            </div>

        </div>
    );
}

export default withStyles(bt, s)(PrefferedProviderDetails);
